import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import {FormArray, FormGroup} from "@angular/forms";
import {
  JaarrapportageEntity, ClientEntity, TrialBalanceItem, Jaarrekening, Jaarrapportage, BokkzJrLogic
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzAlgDataService, BokkzJrDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { FeatureTaxReportDetailsComponent } from '../../tax-report-details/feature-tax-report-details.component';
import { combineLatest, distinctUntilChanged, Observable, ReplaySubject, Subject, takeUntil } from "rxjs";
import { SpecFormattedexplanationComponent } from '../spec-formattedexplanation/spec-formattedexplanation.component';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-toelichting-niet-in-balans-opgenomen-activa-verplichtingen',
  templateUrl: './toelichting-niet-in-balans-opgenomen-activa-verplichtingen.component.html',
  imports: [
    SpecFormattedexplanationComponent,
    SharedUiDetailsModule,
    SharedUiButtonModule,
    SharedUiFormControlsModule,
    CommonModule
  ],
  styleUrls: ['./toelichting-niet-in-balans-opgenomen-activa-verplichtingen.component.css']
})
export class ToelichtingNietInBalansOpgenomenActivaVerplichtingenComponent implements OnInit, OnChanges, OnDestroy {

  @Input() public id!: string;
  @Input() selectedTabObservable!: Observable<number>;
  private selectedTabSubject = new ReplaySubject<number>(1);
  showCustomControls = true;
  private destroy$ = new Subject<void>();
  public selectedTab = 0;
  public index = 0;
  public dialogVisible = false;
  public client = {} as ClientEntity;
  public jrEntity = {} as JaarrapportageEntity;
  public isRechtspersoon = false;

  public offBalanceSheetArrangementsDisclosureFg = {} as FormGroup;
  public offBalanceSheetCommitmentsDisclosureFg = {} as FormGroup;
  public offBalanceSheetAssetsDisclosureFg = {} as FormGroup;
  public operatingLeasesDisclosureFg = {} as FormGroup;

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    {value: true, label: "Ja"},
    {value: false, label: "Nee"},
  ];

  public showDialog(input: number) {
    this.index = input
    this.dialogVisible = true;
  }

  constructor(
    public algDataService: BokkzAlgDataService,
    private cdRef: ChangeDetectorRef,
    public jrDataService: BokkzJrDataService) {
    this.createFormGroups();
  }

  ngOnInit(): void {
    if (this.selectedTabObservable) {
      this.selectedTabObservable
        .pipe(takeUntil(this.destroy$))
        .subscribe(tab => {
          this.selectedTabSubject.next(tab);
        });
    }

    combineLatest([
      this.selectedTabSubject.pipe(distinctUntilChanged()),
      this.jrDataService.jaarrapportageEntity
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([tab, jrEntity]) => {
        this.selectedTab = tab;
        this.jrEntity = jrEntity;
        this.patchData(jrEntity);
      });

    this.jrDataService.isRechtspersoon.subscribe((value) => {
      this.isRechtspersoon = value;
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedTabObservable']) {
      this.selectedTabObservable = changes['selectedTabObservable'].currentValue;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public createFormGroups() {
    this.offBalanceSheetArrangementsDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.offBalanceSheetCommitmentsDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.offBalanceSheetAssetsDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.operatingLeasesDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
  }

  private patchData(value: JaarrapportageEntity) {
    const tekstueel = value.rapportage?.jaarrekeningen?.at(0)?.toelichting.toelichtingBalans?.nietInBalansOpgenomenActivaVerplichtingen?.nietInBalansOpgenomenActivaVerplichtingenTekstueel;
    if (tekstueel) {
       if (tekstueel.offBalanceSheetArrangementsDisclosure) {
         this.offBalanceSheetArrangementsDisclosureFg.patchValue(tekstueel.offBalanceSheetArrangementsDisclosure);
       }
       if (tekstueel.offBalanceSheetCommitmentsDisclosure) {
         this.offBalanceSheetCommitmentsDisclosureFg.patchValue(tekstueel.offBalanceSheetCommitmentsDisclosure);
       }
       if (tekstueel.offBalanceSheetAssetsDisclosure) {
         this.offBalanceSheetAssetsDisclosureFg.patchValue(tekstueel.offBalanceSheetAssetsDisclosure);
       }
       if (tekstueel.operatingLeasesDisclosure) {
         this.operatingLeasesDisclosureFg.patchValue(tekstueel.operatingLeasesDisclosure);
       }
     }
  }

  public saveForm(): void {
    this.showCustomControls = false;
    this.cdRef.detectChanges();
    setTimeout(() => {
      this.showCustomControls = true;
      this.cdRef.detectChanges();
    });

    this.offBalanceSheetArrangementsDisclosureFg.updateValueAndValidity({ emitEvent: false });
    this.offBalanceSheetCommitmentsDisclosureFg.updateValueAndValidity({ emitEvent: false });
    this.offBalanceSheetAssetsDisclosureFg.updateValueAndValidity({ emitEvent: false });
    this.operatingLeasesDisclosureFg.updateValueAndValidity({ emitEvent: false });

    if (this.jrEntity && this.jrEntity.rapportage && this.jrEntity.rapportage.jaarrekeningen) {
      this.jrEntity.rapportage.jaarrekeningen[0] = {
        ...this.jrEntity.rapportage.jaarrekeningen[0],
        toelichting: {
          ...this.jrEntity.rapportage.jaarrekeningen[0].toelichting,
          toelichtingBalans: {
            ...this.jrEntity.rapportage.jaarrekeningen[0].toelichting?.toelichtingBalans,
            nietInBalansOpgenomenActivaVerplichtingen: {
              ...this.jrEntity.rapportage?.jaarrekeningen[0].toelichting?.toelichtingBalans?.nietInBalansOpgenomenActivaVerplichtingen,
              nietInBalansOpgenomenActivaVerplichtingenTekstueel: {
                ...this.jrEntity.rapportage?.jaarrekeningen[0].toelichting?.toelichtingBalans?.nietInBalansOpgenomenActivaVerplichtingen?.nietInBalansOpgenomenActivaVerplichtingenTekstueel,
                offBalanceSheetArrangementsDisclosure: this.offBalanceSheetArrangementsDisclosureFg.value,
                offBalanceSheetCommitmentsDisclosure: this.offBalanceSheetCommitmentsDisclosureFg.value,
                offBalanceSheetAssetsDisclosure: this.offBalanceSheetAssetsDisclosureFg.value,
                operatingLeasesDisclosure: this.operatingLeasesDisclosureFg.value,
              }
            },
          }
        }
      } as Jaarrekening
    }

    this.jrEntity = {
      ...this.jrEntity,
      rapportage: {
        ...this.jrEntity.rapportage,
        jaarrekeningen: [this.jrEntity.rapportage?.jaarrekeningen?.at(0)]
      }
    } as Jaarrapportage
    this.jrDataService.updateEntity(this.jrEntity);
  }
}
